<template>
  <div ref="contentList"
       v-loading="loading">
    {{itemWidth}}
    <waterfall :col="4"
               :width="235"
               :gutterWidth='15'
               :data="itemList">
      <template>

        <div style="margin-bottom:10px"
             v-for="(o, index) in itemList"
             :key="index">
          <!-- 内容 -->
          <el-card shadow="hover"
                   :body-style="{ padding: '0px' }">

            <div class="content_image">
              <!-- 图片 -->
              <img class="image"
                   :style="imageSize"
                   @click="clickCard(o)"
                   :src="o.image" />
              <!-- 角标 -->
              <div v-if="o.corner_name!==''"
                   class="content_list_corner_dest">{{o.corner_name}}</div>
              <!-- 二维码 -->
              <div class="hover_image">
                <show-qr-code :size="100"
                              :code="o.id"
                              type="contentReview"></show-qr-code>
              </div>
            </div>
            <!-- 内容盒子 -->
            <div style="padding: 14px;height:auto">
              <!-- 产品标题:有2行，超过之后用... 显示 -->
              <div @click="clickCard">
                <h3 class="card-first-title">
                  {{ o.title }}
                </h3>
                <!-- 下标 -->
                <div v-if="o.title_mini"
                     class="title_mini_style"
                     style="font-size: 5px">{{titleMiniName}} {{ o.title_mini }}</div>
              </div>
              <!-- 标签 -->
              <div v-if="showTag">
                <span style="font-size: 13px">标签:</span>
                <el-tag style="margin-left: 5px"
                        v-for="(tag_item, index) in o.tag"
                        :key="index"
                        size="mini"
                        type="">
                  {{tag_item.tag_name}}
                </el-tag>
              </div>
              <!-- 目的地 -->
              <div v-if="showDest">
                <span style="font-size: 13px">目的地:</span>
                <el-tag style="margin-left: 5px"
                        v-for="(locitem, index) in o.dest"
                        :key="index"
                        size="mini"
                        type="info">{{ locitem }}</el-tag>
              </div>
              <div class="bottom-item">
                <!-- 更新于日期 -->
                <div v-if="showUpdate"
                     class="time">更新于: {{ o.update_time }}</div>

                <el-button v-if="showButton"
                           @click="makeResveration(o)"
                           type="text"
                           class="button">{{buttonName}}</el-button>
              </div>
            </div>
          </el-card>
        </div>

      </template>
    </waterfall>

  </div>
</template>

<script>
import showQRcode from '../other/hoverShowQRcode.vue'
export default {
  components: {
    'show-qr-code': showQRcode,
  },
  name: 'card-list-component',
  data() {
    return {
      imageSize: `  height: ${this.imageHeight}px; width: ${this.imageWidth}px;`,
      loading: false,
      itemList: this.cardList,
    }
  },
  computed: {
    itemWidth() {},
    gutterWidth() {
      // return 9 * 0.5 * (document.documentElement.clientWidth / 375) //#rem布局 计算x轴方向margin(y轴方向的margin自定义在css中即可)
    },
  },
  props: {
    cardList: {
      type: Array,
      default: () => {
        return [{}, {}, {}, {}]
      },
    },
    titleMiniName: {
      type: String,
      default: '下标题名称:',
    },
    // 显示功能区
    showTitleImage: {
      type: Boolean,
      default: true,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    buttonName: {
      type: String,
      default: '按钮',
    },
    showDest: {
      type: Boolean,
      default: true,
    },
    showTag: {
      type: Boolean,
      default: true,
    },
    showUpdate: {
      type: Boolean,
      default: true,
    },
    // 图片设置
    imageHeight: {
      type: Number,
      default: 235,
    },
    imageWidth: {
      type: Number,
      default: 235,
    },
  },
  methods: {
    clickCard() {},
    makeResveration(value) {
      this.$emit('clickButton', value)
    },
  },
}
</script>

<style>
.content_image {
  position: relative;
}
/* 基本 */
.image {
  display: block;
  cursor: pointer;
}
/* 封面元素 */
.content_list_corner_dest {
  position: absolute;
  font-size: 13px;
  color: #fff;
  padding: 0 10px;
  background-color: #ff5421;
  /* width: 30%; */
  top: 0%;
  text-align: center;
}
.hover_image {
  display: none;
}

.content_image:hover .hover_image {
  display: block;
  position: absolute;
  font-size: 13px;
  padding: 0 10px;
  /* background-color: #fff; */
  /* width: 50%; */
  top: 10%;
  right: 10%;
}

.title_mini_style {
  width: 200px;
  cursor: pointer;
  color: grey;
  height: 38px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.button {
  padding: 0;
  float: right;
}

.card-first-title {
  width: 200px;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.bottom-item {
  display: flex;
  margin-top: 5px;
  justify-content: space-between;
}
</style>